import { useTranslation } from "react-i18next";

const FiltersButton: React.FC = ({
  isMapPage,
  isOpen,
  setIsOpen,
  activeFiltersCount,
}: {
  isMapPage: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  activeFiltersCount: number;
}) => {
  const { t } = useTranslation();
  if (!isMapPage) return null;
  return (
    <button
      onClick={() => setIsOpen(!isOpen)}
      className={`flex items-center gap-2 md:ml-[-12px] px-3 py-2 rounded-[8px] border-0 border-secondary transition-all duration-200 bg-secondary text-[#fff] `}
    >
      <img
        src="/icons/filters.svg"
        alt="Filter"
        className={`min-w-3 min-h-3 w-4 h-4 ${
          isOpen ? "brightness-0 invert-0" : "brightness-0 invert"
        }`}
        style={
          isOpen
            ? {
                filter:
                  "brightness(0) saturate(100%) invert(12%) sepia(35%) saturate(5437%) hue-rotate(256deg) brightness(91%) contrast(100%)",
              }
            : {}
        }
      />
      <span className="text-[16px] hidden md:block">
        {t("filters.filters", "Filters")}
      </span>
      {activeFiltersCount > 0 && (
        <span
          className={`flex items-center justify-center w-5 h-5 text-xs font-bold rounded-full ${
            isOpen ? "bg-[#2F0D68] text-white" : "bg-white text-[#2F0D68]"
          }`}
        >
          {activeFiltersCount}
        </span>
      )}
    </button>
  );
};

export default FiltersButton;
